<template>
  <div>
    <v-container container--fluid grid-list-xl>

      <v-card color="#42424211">
        <v-container>
          <v-row align="center" justify="center" class="my-0">
            <v-col cols="9" md="4">
              <v-file-input
                v-model="excelFile"
                label="Error report input"
                hint="select a .xlsx file"
                accept=".xlsx"
                @click:clear="resetData"
              ></v-file-input>
            </v-col>
            <v-col cols="2" md="2">
              <v-btn
                :disabled="!excelFile"
                color="primary"
                class="ma-2 white--text"
                @click="readXLSX"
              >
                <v-icon dark>fas fa-file-import</v-icon>
              </v-btn>
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="8" md="4">
              <v-btn
                :disabled="!isLoaded"
                color="primary"
                block primary
                @click="submitData"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

<!--        <v-divider></v-divider>-->

<!--        <v-expansion-panels>-->
<!--          <v-expansion-panel style="background-color: #00000000" :disabled="!isLoaded">-->
<!--            <v-expansion-panel-header v-slot="{ open }">-->
<!--              <v-card-title class="pa-0">Statistics</v-card-title>-->
<!--            </v-expansion-panel-header>-->
<!--            <v-expansion-panel-content>-->
<!--              <v-container>-->
<!--                <DoughnutChart-->
<!--                  style="height: 40vh"-->
<!--                  ref="chart"-->
<!--                  :chart-data="chartData"-->
<!--                  :options="options"-->
<!--                ></DoughnutChart>-->
<!--              </v-container>-->
<!--            </v-expansion-panel-content>-->
<!--          </v-expansion-panel>-->
<!--        </v-expansion-panels>-->
      </v-card>

      <v-spacer></v-spacer>

      <v-container>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="data"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Delete/Cancel reports</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-container>
    </v-container>
  </div>
</template>

<script>
  import Excel from 'exceljs/dist/exceljs'
  import axios from "axios";

  export default {
    name: "DelCanReportPage",
    data () {
      return {
        excelFile: null,
        idToTableItem: {},
        data: [],
        loading: false,
        isLoaded: false,
        statPanel: false,
        headers : [
          {text: 'Box Number', value: 'Box Number', align: 'center'},
          {text: 'Customer Name', value: 'Customer Name', align: 'center'},
          {text: 'Suburb', value: 'Suburb', align: 'center'},
          {text: 'Production Day', value: 'Production Day', align: 'center'},
          {text: 'Status', value: 'Status', align: 'center'},
        ],

        // chartData: {
        //   labels: errorList,
        //   datasets: [
        //     {
        //       data: [1,1,1,1,1,1,1,1,1],
        //       backgroundColor: colorList,
        //     }
        //   ]
        // },
      }
    },
    methods: {
      resetData(){
        this.statPanel = false;
        this.isLoaded = false;
        this.data = [];
      },

      // computeStat(){
      //   const errorCount = {};
      //   errorList.forEach( error => {
      //     errorCount[error] = 0;
      //   });
      //
      //   this.data.forEach( (deliveries) => {
      //     errorCount[deliveries['bc_error']] = errorCount[deliveries['bc_error']] + 1;
      //   });
      //   console.log(errorCount);
      //   const errorCountList = [];
      //   for (let idx in errorCount){
      //     errorCountList.push( errorCount[idx]);
      //   }
      //   this.chartData.datasets[0].data = errorCountList;
      // },

      readXLSX(){
        const reader = new FileReader();
        const wb = new Excel.Workbook();
        this.loading = true;

        reader.readAsArrayBuffer(this.excelFile);
        reader.onload = () => {
          const buffer = reader.result;
          wb.xlsx.load(buffer).then(workbook => {
            workbook.eachSheet((sheet, id) => {
              sheet.eachRow((row, rowIndex) => {
                if (rowIndex == 1){
                  row.values.forEach( (item, itemId) => {
                    this.idToTableItem[itemId] = item
                  });
                } else {
                  const delivery = {};
                  row.values.forEach( (item, itemId) => {
                    if (this.idToTableItem[itemId]){
                      delivery[this.idToTableItem[itemId]] = item;
                    }
                  });
                  this.data.push(delivery);
                }
              });
              this.loading = false;
              this.isLoaded = true;
            });
          });
        }
      },
      submitData(){
        let proceedAction = 0;
        let notPending = 0;
        let otherError = 0;
        const totalAction = this.data.length;
        this.loading = true;
        this.data.forEach( delivery => {
          axios.get(process.env.API_URL + '/deliveries?serial=' + delivery['Box Number'])
            .then((response) => {
              if (response.data[0]){
                const trackingNum = response.data[0].tracking;
                if (delivery['Status'] === 'DELETE FROM YOUR SYSTEM'){
                  //delete delivery
                  axios.delete(process.env.API_URL + '/deliveries/' + trackingNum, {data: {code: 'DEL', note: ''}})
                          .then((response) => {
                            proceedAction++;
                            if (proceedAction == totalAction){
                              this.$store.commit('displaySnackbar', notPending + ' not pending and ' + otherError + ' launched other errors');
                              this.loading = false;
                            }
                          })
                          .catch((response) => {
                            if (response.response.data.error === 'Delivery ' + trackingNum + ' is not pending'){
                              proceedAction++;
                              notPending++;
                            } else{
                              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                              this.loading = false;
                            }
                          });
                } else if (delivery['Status'] === 'DO NOT DELIVER BOX'){
                  //cancel delivery
                  axios.post(process.env.API_URL + '/deliveries/' + trackingNum + '/cancel', {code: 'CNX', note: 'Cancelled from an execl file'})
                          .then((response) => {
                            proceedAction++;
                            if (proceedAction == totalAction){
                              this.$store.commit('displaySnackbar', notPending + ' deliveries were not pending and ' + otherError + ' deliveries launched other errors');
                              this.loading = false;
                            }
                          })
                          .catch((response) => {
                            if (response.response.data.error === 'Delivery ' + trackingNum + ' is not pending'){
                              proceedAction++;
                              notPending++;
                            } else{
                              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                              this.loading = false;
                            }
                          });
                }
              } else{
                proceedAction++;
                otherError++;
                this.$store.commit('displaySnackbar', 'Delivery data not specified for delivery id ' + delivery['Box Number']);
              }
            })
            .catch((response) => {
              proceedAction++;
              console.log(proceedAction + ' but delivery not found');
              this.$store.commit('displaySnackbar', 'Delivery not found ' + response.response.data.error);
            })
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/ExcelReports/DelCanReportPage.vue